import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import { findMobileOS } from 'yoda-core-components/lib/helpers/Utils/Utils';

export const getCriteoPageEnv = (deviceType, isNative) => {
    let env = 'd';
    if (deviceType?.isMobile || deviceType?.isTablet) {
        env = 'm';
        if (isNative) {
            const appType = findMobileOS();
            if (appType === 'Android') env = 'aa';
            if (appType === 'iOS') env = 'aios';
        }
    }
    return env;
};

export const noLogCheck = (hostname, env) =>
    hostname !== 'www.jcpenney.com' || (hostname === 'www.jcpenney.com' && env === 'development');

export const customerIdCheck = () => {
    let customerId = null;
    const userState = TokenProvider.get('DP_USER_STATE');

    if (userState === '1' || userState === '2') {
        const accountId = TokenProvider.get('ACCOUNT_ID');
        if (accountId) customerId = accountId;
    }

    return customerId;
};

export const getRetailVisitorId = () => {
    let id = LocalStorage.getData('CRITEO_ID');
    if (!id) {
        id = `cu-${new Date().getTime().toString(36)}-${crypto.randomUUID()}`;
        LocalStorage.setData('CRITEO_ID', id);
    }
    return id;
};

export const getPlacementIds = (pageType, irisData, hasIrisCriteoComponent) => {
    // placement-id param only relevant on viewCategory_API
    if (pageType !== 'Gallery' && pageType !== 'Search') {
        return null;
    }

    // can be extended to support other criteo placements
    // format -> placementName: true/false (if placement is expected to render or not)
    const placementMap = {
        InGrid: true, // always supported on gallery and search
        Carousel: hasIrisCriteoComponent(irisData), // can be placed on any microsite
    };

    // if every placement is present, we don't need to add the param
    // only if there is a combination do we consider placement-id
    if (
        Object.values(placementMap).every((value) => value === true) ||
        Object.values(placementMap).every((value) => value === false)
    ) {
        return null;
    }

    let placementIds = '';
    Object.keys(placementMap).forEach((key) => {
        if (placementMap[key]) {
            if (placementIds.length > 0) {
                // placementIds should be separated with |
                placementIds += '|';
            }
            placementIds += key;
        }
    });

    return placementIds;
};
